import React from 'react'

const AdobeSampleSize = () => {
    return (
        <div style={{ height: 'calc(100vh - 95px)' }}>
            <iframe title='AdobeSampleSize' src="https://experienceleague.adobe.com/tools/calculator/testcalculator.html" width="100%" height="100%"></iframe>
        </div>
    )
}

export default AdobeSampleSize;